import React from 'react'
import OurTeam from '../components/OurTeam/OurTeam'

function OurTeamPage() {
  return (
    <div className="page-wrapper">
        <OurTeam />
    </div>
  )
}

export default OurTeamPage